import { CommonModule } from '@angular/common';
import { MonitoringAlertsModule } from './monitoring-alerts/monitoring-alerts.module';
import { MonitoringAreaModule } from './monitoring-area/monitoring-area.module';
import { MonitoringChartModule } from './monitoring-chart/monitoring-chart.module';
import { MonitoringToolbarModule } from './monitoring-toolbar/monitoring-toolbar.module';
import { NgModule } from '@angular/core';
import { MonitoringTreeModule } from './monitoring-tree/monitoring-tree.module';
import { SensorModule } from './sensors/sensor.module';

@NgModule({
    imports: [
        CommonModule,
        MonitoringAlertsModule,
        MonitoringAreaModule,
        MonitoringChartModule,
        MonitoringToolbarModule,
        MonitoringTreeModule,
        SensorModule,
    ],
})
export default class MonitoringModule {}
